module.exports = __webpack_public_path__ + "images/backgrounds/snow/large.149d6adb0c746612aa21.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/snow/large.jpg
// module id = /CGH
// module chunks = 12